const NAVIGATION = {
	install (Vue, options) {
		Vue.prototype.$navigation = {

			goBackToDashboard (taskLabel) {
				let prevRoute = window.localStorage.getItem('prev_route') || { name: null }
				let currentRoute = options.router.currentRoute
				try {
					prevRoute = JSON.parse(prevRoute)
				} catch (error) {
					prevRoute = { name: null }
				}
				let acceptedPrevRoutes = [
					'Maestro manual tasks',
					'Prestations',
					'Maestro jobs',
					'Maestro job',
					'Vantage Configs'
				]
				if (currentRoute.name === 'Maestro job') {
					let route = { name: 'Maestro jobs' }
					if (currentRoute.params) {
						if (currentRoute.params.jr_id) {
							route.query = { jr_id: currentRoute.params.jr_id }
						}
					}
					options.router.push(route).catch(error => {
						console.error(error.message)
					})
				} else if (acceptedPrevRoutes.indexOf(prevRoute.name) > -1) {
					options.router.push(prevRoute).catch(error => {
						console.error(error.message)
					})
				} else {
					let route = { name: 'Maestro manual tasks' }
					if (taskLabel) route.query = { task_label: taskLabel }
					options.router.push(route).catch(error => {
						console.error(error.message)
					})
				}
			}

		}
	}
}

export default NAVIGATION



// WEBPACK FOOTER //
// ./src/plugins/navigation.js